import { reducer as form } from 'redux-form';
import * as SECURE_MESSAGE_ACTION_TYPES from '../secure-message/actions/types';
import * as CREATE_ACCOUNT_ACTION_TYPES from '../signup/create-account/create-account-actiontype';

export default form.plugin({
  securemessageform: (state, action) => {
    switch (action.type) {
      case SECURE_MESSAGE_ACTION_TYPES.CARE_PROVIDER_SELECTED:
        return {
          ...state,
          values: { recipient: action.recipient },
        };
      default:
        return state;
    }
  },
  createaccountform: (state, action) => {
    switch (action.type) {
      case CREATE_ACCOUNT_ACTION_TYPES.SET_EMAIL:
        return {
          ...state,
          email: { value: action.email },
          username: { value: action.email },
        };
      case CREATE_ACCOUNT_ACTION_TYPES.CLEAR_PASSWORD:
        return {
          ...state,
          password: { value: '' },
          confirmpassword: { value: '' },
        };
      default:
        return state;
    }
  },
});
